import { Component, OnInit } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";



@Component({
  selector: 'app-add-contact-modal',
  templateUrl: './add-contact-modal.component.html',
  styleUrls: ['./add-contact-modal.component.scss'],

})
export class AddContactModalComponent implements OnInit {

  public contact_detail: any = {};
  

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    

  ) {}

  ngOnInit() {}

  public closeModal() {
    this.bsModalRef.hide();
    /*   this.modalService.setDismissReason('modalClosed');*/
    this.modalService.setDismissReason("modalClosed");
  }

  public closeModalAfterSave() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("modalSaved");
  }

  public createContact(event) {
    this.closeModalAfterSave()
  }

}



// WEBPACK FOOTER //
// /app/src/app/supplier-evaluation-form/add-contact-modal/add-contact-modal.component.ts